import { render, staticRenderFns } from "./Redemptions.vue?vue&type=template&id=e183e47a&scoped=true&"
import script from "./Redemptions.vue?vue&type=script&lang=ts&"
export * from "./Redemptions.vue?vue&type=script&lang=ts&"
import style0 from "./Redemptions.vue?vue&type=style&index=0&id=e183e47a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e183e47a",
  null
  
)

export default component.exports